import { Button, Card, Col, Form, Input, Row, Space, message } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import DropdownSelect from "../../../components/common/select";
import FileUpload from "../../../components/common/upload-file/FileUpload";
import InputBox from "../../../components/common/input";

import {
  addAdvertisement,
  getAdvDetailsData,
  updateAdv,
} from "../../../redux/action/advertisement/advertisingAction";
import { useDispatch, useSelector } from "react-redux";

const options = [
  { label: "Top", value: 1 },
  { label: "Bottom", value: 0 },
];

const AddAdvertising = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const isEditMode = location.pathname.includes("edit");

  const advDetails = useSelector((store) => store.getAdvDetailsData?.data);
  const { isLoading } = useSelector((store) => store.getAdvDetailsData);

  useEffect(() => {
    if (isEditMode && params?.id) {
      dispatch(getAdvDetailsData(params.id));
    }
  }, [isEditMode, params?.id, dispatch]);

  const [previewImages, setPreviewImages] = useState({
    url_en: null,
    url_es: null,
    url_pt: null,
  });

  useEffect(() => {
    if (isEditMode && advDetails && Object.keys(advDetails).length > 0) {
      form.setFieldsValue(advDetails);

      setPreviewImages({
        url_en: advDetails.url_en
          ? `${process.env.REACT_APP_API_IMG_URI}/${advDetails.url_en}`
          : null,
        url_es: advDetails.url_es
          ? `${process.env.REACT_APP_API_IMG_URI}/${advDetails.url_es}`
          : null,
        url_pt: advDetails.url_pt
          ? `${process.env.REACT_APP_API_IMG_URI}/${advDetails.url_pt}`
          : null,
      });
    }
  }, [isEditMode, advDetails, form]);

const handleFinish = async (values) => {
  try {
      const values = await form.validateFields();
    if (isEditMode) {
      await dispatch(updateAdv(params?.id, values, () => navigate(-1)));
    } else {
      await dispatch(addAdvertisement(values, () => navigate(-1)));
    }
  } catch (error) {
    console.log("Validation Failed or API Error:", error);
  }
};

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };
  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {isEditMode
            ? "Edit Advertisement Details"
            : "Add Advertisement Details"}
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save Details
          </Button>
        </Space>
      </div>
      <Card loading={isLoading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{ banner_position: undefined }}
        >
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="title_en"
                label="Banner Title"
                rules={[{ required: true, message: "Please enter banner title" }]}
              >
                <Input size="large" placeholder="Enter banner title" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="position"
                label="Banner Position"
                rules={[{ required: true, message: "Please select banner position" }]}
              >
                <DropdownSelect options={options} placeholder="Choose..." />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item name="link_en" label="Add Link">
                <InputBox size="large" placeholder="Add Link" />
              </Form.Item>
            </Col>
          </Row>

          {/* ✅ Next row for images */}
          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="url_en"
                label="Upload Banner (en)"
                rules={[{ required: true, message: "Please upload a banner file" }]}
              >
                <FileUpload
                  label2="Advertisement Banner File"
                  maxFileSizeText="Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                  setFieldValue={(url) => handleUploadSuccess("url_en", url)}
                  initialPreview={previewImages.url_en}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                name="url_es"
                label="Upload Banner (es)"
                rules={[{ required: true, message: "Please upload a banner file" }]}
              >
                <FileUpload
                  label2="Advertisement Banner File"
                  maxFileSizeText="Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                  setFieldValue={(url) => handleUploadSuccess("url_es", url)}
                  initialPreview={previewImages.url_es}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item
                name="url_pt"
                label="Upload Banner (pt)"
                rules={[{ required: true, message: "Please upload a banner file" }]}
              >
                <FileUpload
                  label2="Advertisement Banner File"
                  maxFileSizeText="Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                  setFieldValue={(url) => handleUploadSuccess("url_pt", url)}
                  initialPreview={previewImages.url_pt}
                />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Card>
    </div>
  );
};

export default AddAdvertising;
